// Centralized data-testids for the Indiora Journeys redesign
export const NAV = {
  brand: "nav-brand-link",
  home: "nav-home-link",
  destinations: "nav-destinations-link",
  about: "nav-about-link",
  journal: "nav-journal-link",
  contact: "nav-contact-link",
  cta: "nav-inquire-cta",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HOME = {
  heroTitle: "home-hero-title",
  heroCta: "home-hero-cta",
  philosophyCta: "home-philosophy-cta",
  destinationCard: (slug) => `home-destination-card-${slug}`,
  experiencesSection: "home-experiences-section",
  testimonialsSection: "home-testimonials-section",
  inquireSection: "home-inquire-section",
};

export const DEST = {
  pageTitle: "destinations-page-title",
  sectionAnchor: (slug) => `destination-section-${slug}`,
  galleryImage: (slug, i) => `destination-${slug}-gallery-${i}`,
};

export const ABOUT = {
  pageTitle: "about-page-title",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  subject: "contact-input-subject",
  destination: "contact-select-destination",
  message: "contact-input-message",
  submit: "contact-submit-button",
  success: "contact-success-message",
  error: "contact-error-message",
  emailLink: "contact-email-link",
  instagramLink: "contact-instagram-link",
};

export const FOOTER = {
  root: "site-footer",
  inquiry: "footer-inquiry-link",
};
